export default "__VITE_ASSET__XsiZocIa__"